import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';

import { ENV_VARS } from 'ENV_CONFIG';
import styles from './CompletedBooking.scss';
import { apiCallFinished, Title } from '../../components';
import { bookingsActions } from '~/api';

export class CompletedBooking extends PureComponent {
  state = {
    scrollOnTop: undefined,
  };

  componentDidMount() {
    const { dispatchApiCallFinished, dispatchSetBookingCompleted } = this.props;

    dispatchApiCallFinished(true);
    dispatchSetBookingCompleted(true);
    window.addEventListener('scroll', this.setScrollToTop);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.setScrollToTop);
  }

  setScrollToTop = () => {
    const { scrollOnTop } = this.state;
    if (!scrollOnTop && window.pageYOffset !== 0) {
      window.scrollTo(0, 0);
      this.setState({ scrollOnTop: true });
    }
  };

  render() {
    return (
      <section data-testid="CompletedBooking" className={styles.CompletedBooking}>
        <Title id="title" className={styles.Title}>
          Your booking is complete
        </Title>

        <div className={styles.CompletedBooking__info}>
          <p>We look forward to your appointment.</p>
        </div>
        <a href={ENV_VARS.REACT_APP_BROWSE_HOST}>
          <PrimaryButton inline>Continue shopping</PrimaryButton>
        </a>
      </section>
    );
  }
}

CompletedBooking.propTypes = {
  dispatchApiCallFinished: PropTypes.func.isRequired,
  dispatchSetBookingCompleted: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchApiCallFinished: apiCallFinished,
  dispatchSetBookingCompleted: bookingsActions.setBookingCompleted,
};

export const ConnectedCompletedBooking = connect(null, mapDispatchToProps)(CompletedBooking);
